export const initValueLead = {
  //   companyName: "",
  //   // companyId: "",
  //   phone: "",
  //   // phone2: "",
  //   timeZone: "",
  //   companyLinkedIn: "",
  //   website: "",
  //   annualRevenue: "",
  //   revenueType: "",
  //   noOfEmployees: "",
  //   // noOfBeds: "",
  //   businessType: "",
  //   industry: "",
  //   owner: "",
  //   industryId: "",
  //   lineOfBusiness: "",
  //   leadSource: "",
  //   leadSourceId: "",
  //   sourceName: "",
  //   otherSourceName: "",
  //   // suspectOwner: "",
  //   // createdBySystem: "",
  //   // createdBySystemId: "",
  //   // modifiedBySystem: "",
  //   // modifiedBySystemId: "",
  //   firstName: "",
  //   middleName: "",
  //   lastName: "",
  //   title: "",
  //   email: "",
  //   // secondaryEmail: "",
  //   // directPhone: "",
  //   // mobile: "",
  //   contactLinkedIn: "",
  //   // emailOptOut: false,
  //   street: "",
  //   city: "",
  //   state: "",
  //   zipCode: "",
  //   country: "",
  //   description: "",
  //   technologyDetails: "",
  //   // notes: "",
  //   // attachments: "",
  //   // openActivities: "",
  //   // closedActivities: "",
  //   // emailsSent: "",
  //   // campaigns: "",
  //   // invitedMeetings: "",

  companyName: '',
  displayName: '',
  shortName: '',
  phone: '',
  alternatePhone: '',
  otherSourceName: '',
  timeZoneId: '',
  companyLinkedIn: '',
  website: '',
  annualRevenue: null,
  writtenPremium: null,
  revenueTypeId: '',
  noOfEmployees: null,
  noOfBeds: '',
  businessType: '',
  industryId: '',
  lineOfBusiness: '',
  leadSourceId: '',
  sourceName: '',
  owner: '',
  firstName: '',
  middleName: '',
  lastName: '',
  title: '',
  email: '',
  secondaryEmail: '',
  directPhone: '',
  mobile: '',
  contactLinkedIn: '',
  emailOptOut: false,
  street: '',
  city: '',
  state: '',
  zipCode: '',
  country: '',
  description: '',
  technologyDetails: '',
  accessLevel: '',
  geoScopeNodeId: '',
  geoScopeNode: '',
  orgScopeNodeId: '',
  orgScopeNode: '',
};

export const initValueContact = {
  // contactOwner: "",
  // contactOwnerId: "",
  leadSource: '',
  leadSourceId: '',
  // createdBySystem: "",
  // createdBySystemId: "",
  // modifiedBySystem: "",
  // modifiedBySystemid: "",
  firstName: '',
  middleName: '',
  lastName: '',
  title: '',
  email: '',
  // secondaryEmail: "",
  // department: "",
  accountName: '',
  // accountNameId: "",
  phone: '',
  // mobile: "",
  // reportingTo: "",
  // assistant: "",
  // assistantPhone: "",
  // emailOptOut: false,
  // contactPersonRole: "",
  linkedIn: '',
  twitter: '',
  facebook: '',
  owner: '',
  // skypeId: "",
  // street: "",
  // city: "",
  // state: "",
  // zipCode: "",
  // country: "",
  // description: "",
  // technologyStack: "",
  // notes: [],
  // openActivities: [],
  // closedActivities: [],
  // attachments: [],
  // deals: [],
  // products: [],
  // invitedMeetings: [],
  // cases: [],
  // quotes: [],
  // salesOrders: [],
  // purchaseOrders: [],
  // emails: [],
  // invoices: [],
  // campaigns: [],
  // reportingContacts: [],
};

export const initValueAccount = {
  industry: '',
  // industryId: "",
  accountName: '',
  // accountOwnerId: "",
  // createdBySystem: "",
  // createdBySystemId: "",
  // modifiedBySystem: "",
  // modifiedBySystemId: "",
  // accountName: "",
  // accountId: "",
  accountType: '',
  parentAccount: '',
  // parentAccountId: "",
  phone: '',
  phone2: '',
  companyLinkedIn: '',
  website: '',
  employees: null,
  annualRevenue: null,
  noOfBeds: '',
  owner: '',
  // street: "",
  city: '',
  state: '',
  zipCode: '',
  country: '',
  // description: "",
  // technologyDetails: "",
  // notes: "",
  // attachments: [],
  // deals: [],
  // contacts: [],
  // openActivities: [],
  // closedActivities: [],
  // emails: [],
  // invoices: [],
  // products: [],
  // quotes: [],
  // salesOrders: [],
};

export const initValueOpportunity = {
  name: '',
  accountId: '',
  contactId: '',
  projectTypeId: '',
  nextStep: '',
  forecastCategoryId: '',
  amount: null,
  stageId: '',
  probability: null,
  closingDate: null,
  expectedRevenue: null,
  campaignSource: '',
  reachOutForMarketing: null,
  description: '',
  technologyStack: '',
  owner: '',
  ownerId: '',
  industryId: '',
  businessType: '',
  leadSourceId: '',
  sourceName: '',
  lineOfBusiness: '',
};

export const initValueCampaign = {
  owner: '',
  ownerId: '',
  campaignName: '',
  campaignTypeId: '',
  statusId: '',
  senderEmail: '',
  senderName: '',
  templateId: '',
  campaignStatus: 'Active',
  // startDate: "",
  // endDate: "",
  description: '',
};
export const initValueTicket = {
  ownerId: '',
  subject: '',
  // dueDate: "",
  statusId: '',
  priorityId: '',
  description: '',
  owner: '',
  reminder: null,
};

export const initValueProduct = {
  name: '',
  description: '',
  categoryId: '',
  productType: '',
  baseCost: 0,
  basePrice: 0,
  currency: '',
  productOwner: '',
  productCode: '',
  productActive: true,
  productCategory: '',
  salesStartDate: null,
  salesEndDate: null,
  supportEndDate: null,
  vendorName: '',
  manufacturer: '',
  unitPrice: 0,
  commissionRate: 0,
  tax: '',
  usageUnit: '',
  quantityInStock: 0,
  handler: '',
  quantityOrdered: 0,
  reorderLevel: 0,
  quantityInDemand: 0,
};

export const initValuePrice = {
  name: '',
  description: '',
  currencyPrice: '',
  startDate: null,
  endDate: null,
};

export const initValueQuote = {
  quoteStageId: '',
  quoteStage: '',
  quoteOwnerId: '',
  quoteOwner: '',
  subject: '',
  team: '',
  accountId: '',
  accountName: '',
  opportunityId: '',
  opportunity: '',
  billingStreet: '',
  billingCity: '',
  billingState: '',
  billingCountry: '',
  billingCode: '',
  shippingStreet: '',
  shippingCity: '',
  shippingState: '',
  shippingCountry: '',
  shippingCode: '',
  descriptionInformation: '',
  quoteDetails: [
    {
      productId: '',
      description: '',
      status: '',
      currencyPrice: '',
      discountPercent: 0,
      discountAmount: 0,
      taxPercent: 0,
      taxAmount: 0,

      remarks: '',
    },
  ],
};

export const columnTypes = {
  text: {
    filter: 'agTextColumnFilter',
    sortable: true,
    editable: true,
  },
  date: {
    filter: 'agDateColumnFilter',
    sortable: true,
    valueFormatter: (params) => (params.value ? new Date(params.value).toLocaleDateString() : ''),
  },
  number: {
    filter: 'agNumberColumnFilter',
    sortable: true,
    editable: true,
  },
  dropdown: {
    editable: true,
    cellEditor: 'agSelectCellEditor',
    filter: 'agSetColumnFilter',
  },
  checkbox: {
    editable: true,
    cellRenderer: 'agCheckboxCellRenderer', // For display
    cellEditor: 'agCheckboxCellEditor', // Optional, if you want editing
    filter: 'agSetColumnFilter',
  },
};

export const initValueSalesOrder = {
  id: '',
  code: '',
  orderNumber: '',
  quoteId: '',
  accountId: '',
  contactId: '',
  quantity: 0,
  unitQuantity: 0,
  price: 0,
  subTotal: 0,
  discountTotal: 0,
  taxTotal: 0,
  shippingCharges: 0,
  grandTotal: 0,
  salesOwner: '',
  subject: '',
  customerNo: '',
  quoteName: '',
  carrier: '',
  salesCommission: 0,
  accountName: '',
  dealName: '',
  purchaseOrder: '',
  dueDate: null,
  contactName: '',
  exciseDuty: 0,
  status: '',
  billingStreet: '',
  billingCity: '',
  billingState: '',
  billingCode: '',
  billingCountry: '',
  shippingStreet: '',
  shippingCity: '',
  shippingState: '',
  shippingCode: '',
  shippingCountry: '',
  termsAndConditions: '',
  descriptionInformation: '',
  orderDate: '',
  saleOrderDetails: [
    {
      productId: '',
      description: '',
      discountPercent: 0,
      discountAmount: 0,
      taxPercent: 0,
      taxAmount: 0,
      lineTotal: 0,
      id: '',
      priceSheetId: null,
      currency: "",
      quantity: 0,
      listPrice: 0,
      taxAmount: 0,
    },
  ],
};
export const initValueInvoice = {
  code: '',
  invoiceNumber: '',
  salesOrderId: null,
  accountId: '',
  billingContactId: '',
  quantity: 0,
  price: 0,
  discountPercent: 0,
  status: '',
  subTotal: 0,
  discountTotal: 0,
  taxTotal: 0,
  shippingCharges: 0,
  grandTotal: 0,
  amountPaid: 0,
  balanceDue: 0,
  paymentTermsId: '',
  invoiceOwner: '',
  invoiceOwnerId: '',
  subject: '',
  invoiceDate: null,
  dueDate: null,
  salesCommission: 0,
  currencyPrice: '',
  accountName: '',
  contactName: '',
  contactId: '',
  salesOrder: null,
  purchaseOrder: '',
  exciseDuty: 0,
  billingStreet: '',
  billingCity: '',
  billingState: '',
  billingCode: '',
  billingCountry: '',
  shippingStreet: '',
  shippingCity: '',
  shippingState: '',
  shippingCode: '',
  shippingCountry: '',
  paymentMethod: '',
  paymentDate: null,
  referenceNumber: '',
  termsAndConditions: '',
  descriptionInformation: '',
  invoiceDetails: [
    {
      id: '',
      invoiceId: '',
      lineNo: 0,
      productId: '',
      priceSheetId: '',
      description: '',
      discountAmount: 0,
      taxPercent: 0,
      taxAmount: 0,
      lineTotal: 0,
      remarks: '',
    },
  ],
};
export const initValueSqBasicDetails = {
  sequenceName: "",
  sequenceOwner: "",
  sequenceType: "",
  status: "",
  // scheduledDateTime: "2025-10-06T14:41:34.157Z",
  targetModule: "",
  mode: "",
  maxRecipientsPerBatch: 0
};
